// Status -> presentation. Red/Yellow/Green restricted to performance; Blue for review.
export const STATUS_META = {
  "On Track": { badge: "bg-emerald-50 text-emerald-800 border-emerald-200", row: "bg-emerald-50/40", dot: "#10B981" },
  "Watch": { badge: "bg-amber-50 text-amber-800 border-amber-200", row: "bg-amber-50/40", dot: "#F59E0B" },
  "Unfavorable": { badge: "bg-red-50 text-red-800 border-red-200", row: "bg-red-50/40", dot: "#EF4444" },
  "Not Started": { badge: "bg-slate-100 text-slate-600 border-slate-200", row: "", dot: "#94A3B8" },
};

export function statusMeta(status) {
  if (STATUS_META[status]) return STATUS_META[status];
  // any Review:* or Duplicate
  return { badge: "bg-blue-50 text-blue-800 border-blue-200", row: "bg-blue-50/40", dot: "#3B82F6" };
}

export function pfColor(v) {
  if (v === null || v === undefined) return "text-slate-400";
  if (v >= 1.0) return "text-emerald-700";
  if (v >= 0.9) return "text-amber-700";
  return "text-red-700";
}

export function gainColor(v) {
  if (v === null || v === undefined || v === 0) return "text-slate-600";
  return v > 0 ? "text-emerald-700" : "text-red-700";
}
